








helpers = require('../../../../helpers.coffee')

view_model = {
  props: ['notification', 'table']

  data: ->
    current_user: Session.current_user
    go_to: "/fluxos-de-cadencia/" + @notification.metadata.flow_id

  computed:
    flow_name: ->
      @notification.flow_name

    flow_id: ->
      @notification.flow_id
}

exports.default = helpers.vue_include(view_model, helpers.notifications.kind_wrapper)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/kind/contact_interrupted.vue